export default __webpack_public_path__ + "static/bt_techstack-524031bdc412b5172f88a75c28bde09c.png";